import './NavigationButtons.css';

interface NavigationButtonsProps {
	currentSlide: number;
	totalSlides: number;
	onSlideChange: (index: number) => void;
}

const NavigationButtons = ({ currentSlide, totalSlides, onSlideChange }: NavigationButtonsProps) => {
	return (
		<section id="navigation-buttons">
			<button
				type="button"
				onClick={() => onSlideChange(currentSlide - 1)}
				disabled={currentSlide === 0}
				className="prev-button"
				aria-label="Previous slide"
			>
				<div className="icon icon-angle-left" aria-hidden="true" />
			</button>
			<button
				type="button"
				onClick={() => onSlideChange(currentSlide + 1)}
				disabled={currentSlide === totalSlides - 1}
				className="next-button"
				aria-label="Next slide"
			>
				<div className="icon icon-angle-right" aria-hidden="true" />
			</button>
		</section>
	);
};

export default NavigationButtons;
